import type { RouteRecordRaw } from 'vue-router'
import { RouteList } from '@/routes/RouteList'

const UnsubscribeView = () => import('@/views/Public/Unsubscribe/UnsubscribeView.vue')

const PublicSchedulerView = () => import('@/views/Public/Scheduler/PublicSchedulerView.vue')
const PublicSchedulerInlineView = () =>
  import('@/views/Public/Scheduler/PublicSchedulerInlineView.vue')
const PublicSchedulerInlineDocView = () =>
  import('@/views/Public/Scheduler/PublicSchedulerInlineDocView.vue')

export default <RouteRecordRaw[]>[
  {
    path: RouteList.PUBLIC.UNSUBSCRIBE.PATH,
    name: RouteList.PUBLIC.UNSUBSCRIBE.NAME,
    components: {
      default: UnsubscribeView,
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: RouteList.PUBLIC.SCHEDULER.PATH,
    name: RouteList.PUBLIC.SCHEDULER.NAME,
    component: PublicSchedulerView,
  },
  {
    path: RouteList.PUBLIC.SCHEDULER_INLINE.PATH,
    name: RouteList.PUBLIC.SCHEDULER_INLINE.NAME,
    component: PublicSchedulerInlineView,
  },
  {
    path: RouteList.PUBLIC.SCHEDULER_INLINE_DOC.PATH,
    name: RouteList.PUBLIC.SCHEDULER_INLINE_DOC.NAME,
    component: PublicSchedulerInlineDocView,
  },
]
